/**
 * Track geolocation events to local client-view buffer, buyer analytics, and server.
 */
import { trackBuyerEvent } from "../../utils/buyerAnalytics";
import { trackEvent } from "../api/publicClientViewApi";
import { appendClientViewLocalAnalyticsEvent } from "./clientViewLocalAnalyticsEventStore";
import { buildGeolocationAnalyticsPayload } from "./geolocationAnalytics";
import { getSessionId, getVisitorId } from "./session";

function randomEventId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `cv-geo-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function trackClientViewGeolocationEvent(
  slug,
  eventType,
  {
    latitude = null,
    longitude = null,
    accuracyMeters = null,
    method = "gps",
    errorCode = null,
    analyticsEnabled = true,
  } = {}
) {
  if (!slug || !eventType) return null;

  const metadata = buildGeolocationAnalyticsPayload({
    slug,
    latitude,
    longitude,
    accuracyMeters,
    method,
    errorCode,
  });

  const localEvent = {
    id: randomEventId(),
    eventType,
    slug,
    sessionId: getSessionId(),
    visitorId: getVisitorId(),
    metadata,
    occurredAt: new Date().toISOString(),
  };

  appendClientViewLocalAnalyticsEvent(localEvent);

  trackBuyerEvent(eventType, {
    ...metadata,
    sourceComponent: "client_view_geolocation",
    sourceAction: eventType,
  });

  if (analyticsEnabled !== false) {
    Promise.resolve(
      trackEvent(slug, {
        eventType,
        sessionId: localEvent.sessionId,
        visitorId: localEvent.visitorId,
        pagePath: typeof window !== "undefined" ? window.location.pathname : null,
        metadata,
        occurredAt: localEvent.occurredAt,
      })
    ).catch(() => {});
  }

  return localEvent;
}
